import {clsx} from 'clsx'
import React, {Fragment, type PropsWithChildren, isValidElement} from 'react'

import styles from './Footer.module.css'

export default function Footer({children, className}: PropsWithChildren<{className?: string}>) {
  return (
    <ul className={clsx(styles.footer, className)}>
      {
        // eslint-disable-next-line @eslint-react/no-children-to-array
        React.Children.toArray(children)
          .filter(child => !!child) // Filter out falsy children to avoid putting spacers around `null` or `false`
          .map((child, i) => {
            const key = `footer-item-${isValidElement(child) ? child.key : i}`
            const spacer = i === 0 ? null : <FooterSpacer />
            return (
              <Fragment key={key}>
                {spacer}
                {child}
              </Fragment>
            )
          })
      }
    </ul>
  )
}

function FooterSpacer() {
  return (
    <span aria-hidden className={styles.spacer}>
      ·
    </span>
  )
}

export function FooterItem({children}: PropsWithChildren) {
  return <li className={styles.footerItem}>{children}</li>
}
